var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 45,
    viewBox: "0 0 54 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7371 27.2377H21.5416V41.4475H19.7371V43.2238H5.30122V41.4475H3.49673V27.2377H5.30122V25.4615H19.7371V27.2377Z",
    fill: "#F86C14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7371 5.9232H21.5416V20.133H19.7371V21.9093H5.30122V20.133H3.49673V5.9232H5.30122V4.14697H19.7371V5.9232Z",
    fill: "#F86C14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.391 27.2377H43.1955V41.4475H41.391V43.2238H26.9551V41.4475H25.1506V27.2377H26.9551V25.4615H41.391V27.2377Z",
    fill: "#F86C14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1955 5.9232V20.133H41.391V21.9093H26.9551V20.133H25.1506V5.9232H26.9551V4.14697H41.391V5.9232H43.1955Z",
    fill: "#F86C14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0449 24.8672H19.8494V39.0771H18.0449V40.8533H3.60902V39.0771H1.80453V24.8672H3.60902V23.091H18.0449V24.8672Z",
    fill: "#FFC700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0449 3.55247H19.8494V17.7623H18.0449V19.5385H3.60902V17.7623H1.80453V3.55247H3.60902V1.77625H18.0449V3.55247Z",
    fill: "#FFC700"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6986 24.8672H41.5031V39.0771H39.6986V40.8533H25.2626V39.0771H23.4582V24.8672H25.2626V23.091H39.6986V24.8672Z",
    fill: "#FFC700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5031 3.55247V17.7623H39.6986V19.5385H25.2626V17.7623H23.4582V3.55247H25.2626V1.77625H39.6986V3.55247H41.5031Z",
    fill: "#FFC700"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1186_3632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3424 35.0897H40.259V36.0063H39.3424V36.923H38.4257V37.8397H32.9257V32.3397H33.8424V31.423H34.759V30.5063H35.6757V31.423H36.5924V32.3397H37.509V33.2563H38.4257V34.173H39.3424V35.0897Z",
    fill: "#F86C14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5924 25.923H48.5091V27.7563H47.5924V28.673H46.6758V29.5897H45.7591V30.5063H44.8424V31.423H43.9258V32.3397H43.0091V33.2563H42.0924V34.173H41.1758V33.2563H40.2591V32.3397H39.3424V31.423H38.4258V30.5063H37.5091V29.5897H36.5924V28.673H37.5091V27.7563H38.4258V26.8397H39.3424V25.923H40.2591V25.0063H41.1758V24.0897H42.0924V23.173H43.0091V22.2563H44.8424V23.173H45.7591V24.0897H46.6758V25.0063H47.5924V25.923Z",
    fill: "#F86C14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0924 20.423V23.173H52.1758V24.0897H51.2591V25.0064H49.4258V24.0897H48.5091V23.173H47.5924V22.2564H46.6758V21.3397H45.7591V19.5064H46.6758V18.5897H47.5924V17.673H50.3424V18.5897H51.2591V19.5064H52.1758V20.423H53.0924Z",
    fill: "#F86C14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1186_3632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(32.0091 16.7563)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsIcon);
export default __webpack_public_path__ + "static/media/cs_icon.9362a2f473976780f73699090f397781.svg";
export { ForwardRef as ReactComponent };